import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-phone',
  templateUrl: './confirm-phone.component.html',
  styleUrls: ['./confirm-phone.component.scss']
})
export class ConfirmPhoneComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ConfirmPhoneComponent>) { }

  @Input() phoneClient: string = '';
  phone:string = '';
  validationMessages = {
    'phone': {
      'required': 'Por favor ingrese un número de telefono',
      'pattern': "Ingrese un valor válido"
    }
  };
  ngOnInit(): void {
    if (this.phoneClient && this.phoneClient !== '') {
      this.phone = this.phoneClient;
    }
  }
  accept() {
    if (this.phone && this.phone !== '') {
      this.dialogRef.close(this.phone);
    }
  }

}
